import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('helpers.getClonedReportName', {
    copyPostfix: ' (copy)',
});
